import React from 'react';
import { CheckCircle } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'La Guía Maestra del Protocolo PSL',
    desc: '(PDF Digital) El manual completo con la ciencia y la práctica.'
  }, {
    title: 'El Plan de Rescate de 7 Días',
    desc: 'Menú palabra por palabra para desinflamarte rápido.'
  }, {
    title: "La Lista de Supermercado 'Cero Inflamación'",
    desc: 'Para comprar con confianza y sin estrés.'
  }, {
    title: 'Guía de Supervivencia Social',
    desc: 'Cómo comer en fiestas y restaurantes sin hincharte.'
  }, {
    title: 'Diario de Reacción Digestiva',
    desc: 'Para identificar tus disparadores personales.'
  }];
  return <section className="bg-cream py-20 md:py-28" data-id="element-174">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-forest mb-6" data-id="element-177">
            ¿Qué incluye tu Protocolo PSL?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-178"></div>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-sm shadow-xl border-t-4 border-gold" data-id="element-179">
          <ul className="space-y-6" data-id="element-180">
            {deliverables.map((item, index) => <li key={index} className="flex items-start gap-4 p-4 hover:bg-sage/20 rounded-sm transition-colors duration-300" data-id="element-181">
                <CheckCircle className="w-6 h-6 text-forest mt-1 flex-shrink-0" strokeWidth={2} data-id="element-182" />
                <div data-id="element-183">
                  <h3 className="text-xl font-heading font-bold text-forest mb-1" data-id="element-184">
                    {item.title}
                  </h3>
                  <p className="text-dark/80 font-body" data-id="element-185">{item.desc}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}